import getApiClient from '@/plugins/api'

export default {
  save: function () {
    const api = getApiClient(this.$store)

    this.$store.commit('startLoading')
    this.resetErrors()

    let endpoint = 'boarding_places'
    let method = 'post'
    let extraHeaders = {}

    if (this.boardingPlace.id) {
      endpoint = `boarding_places/${this.boardingPlace.id}`
      method = 'patch'
      extraHeaders = {
        'Content-Type': 'application/merge-patch+json'
      }
    }

    let postData = this.boardingPlace

    postData.latitude = parseFloat(postData.latitude ?? 0)
    postData.longitude = parseFloat(postData.longitude ?? 0)

    api[method](endpoint, postData, {headers: extraHeaders})
      .then(() => {
        this.error = false
        this.success = true
      })
      .catch(error => {
        this.error = true
        this.success = false
        const violations = error.response.data?.violations ?? []

        violations.forEach((violation) => {
          this.errors[violation.propertyPath] = violation.message
        })
      })
      .finally(() => {
        this.$store.commit('stopLoading')
      })
  },

  loadBoardingPlace() {
    if (this.$route.params.id) {
      const api = getApiClient(this.$store)

      this.$store.commit('startLoading')
      api.get(`/boarding_places/${this.$route.params.id}`)
        .then(result => {
          this.boardingPlace = result.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('stopLoading')
        })
    }
  },

  resetErrors() {
    this.errors = {
      title: null,
      city: null,
      state: null,
    }
  }
}
